export const isNotNullOrUndef = (x) => {
    return x !== null && x !== undefined;
};
